import { httpClient } from '../transports/http.js'
import WebCalculations from '../webCalculations.js'

export async function getDirectionsAndCategories() {
  return (await httpClient.post('api/_EAM.QR.GETDIRANDCAT', {})).data
}

export async function getWorkRequests(params) {
  return (await httpClient.post('api/_EAM.QR.GETWORKREQUESTS', params)).data
}

export async function addWorkRequest(isAuth, params, imageFiles) {
  const workRequestId = (await httpClient.post('api/' + (isAuth ? '_EAM.QR.ADDWORKREQUEST.AUTH'
    : 'EAM.QR.ADDWORKREQUEST'), params)).data
  if (workRequestId != 0 && imageFiles && imageFiles.length) {
    return WebCalculations.submitFiles({
      files: imageFiles,
      parameters: {
        table: 'RZA',
        keyvalue: workRequestId.toString().padStart(7, ' ')
      }
    }).then(() => { return workRequestId })
  }
  else {
    return Promise.resolve(workRequestId)
  }
}

export async function getDocumentInfo(params) {
  return (await httpClient.post('api/DOCMANAGER.GETDOCINFO', { ARSO: 'RZA', KEYVALUE: params.workRequestId.toString().padStart(7, ' '), KIDCOPY: '' })).data
}
  
export async function getAdditionalInformation(params) {
  return (await httpClient.post('api/_EAM.QR.PERFORMERANDDECLARER', params)).data
}

export async function modifyWorkRequests(params) {
  return (await httpClient.post('api/_EAM.QR.MODIFYREQUEST', params)).data
}

export async function getPerformers(params) {
  return (await httpClient.post('api/_EAM.QR.GETPERFORMERS', params)).data 
}

export async function getCalendar(params) {
  return (await httpClient.post('api/EAM.WORKREQUESTS.HISTORY', params)).data
}

export async function processDocument(params) {
  return (await httpClient.post('api/WFA_MOVE', { ARSO: 'RZA', KEYVALUE: params.workRequestId.toString().padStart(7, ' '), MOVEMODE: params.moveBack ? 0 : 1, COMMENT: params.comment })).data
}